var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Check } from '@mui/icons-material';
import Text from '../Text';
import colors from '../../themes/colors';
var LabelWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])));
var EmptyIcon = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 16px;\n  width: 16px;\n"], ["\n  height: 16px;\n  width: 16px;\n"])));
export var SelectLabel = function (props) {
    var option = props.option;
    return (_jsx(Text, __assign({ variant: "body2", color: "bigBangBlack" }, { children: option.label })));
};
export var SelectLabelWithIcon = function (props) {
    var option = props.option, selectedValue = props.selectedValue;
    var isSelected = option.value === selectedValue;
    return (_jsxs(LabelWrapper, { children: [isSelected ? _jsx(Check, { style: { fontSize: 16, color: colors.bigBangBlack } }) : _jsx(EmptyIcon, {}), _jsx(Text, __assign({ variant: isSelected ? 'body2Semibold' : 'body2', color: "bigBangBlack" }, { children: option.label }))] }));
};
var templateObject_1, templateObject_2;
